module.exports = __webpack_public_path__ + "img/ico-xls.bdc3b27e.jpg";